export default __webpack_public_path__ + "static/media/instagram.1842ffc5.svg";